var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _circle2, _circle3, _circle4, _path15, _circle5, _circle6, _circle7, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupplier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    enableBackground: "new 0 0 96 96",
    height: 512,
    viewBox: "0 0 96 96",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 3h38v31h-38z",
    fill: "#dfdddc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m62 45v-17l-11-19h-10v25h-38v11z",
    fill: "#f2ae40"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 15,
    fill: "#6ebaed",
    r: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m87 21h-6c-3.314 0-6 2.686-6 6v5h18v-5c0-3.314-2.686-6-6-6z",
    fill: "#6ebaed"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m59.68 24h-12.68v-11h6.32z",
    fill: "#ddd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m14 69h11v24h-11z",
    fill: "#dfdddc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m25 59h16v34h-16z",
    fill: "#ddd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m76 93h-35v-21l7-7v7l7-7v7l7-7v7l7-7v7l7-7z",
    fill: "#ef6662"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m76 76h17v17h-17z",
    fill: "#dfdddc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m30 87h6v6h-6z",
    fill: "#9c9b9a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m82 88h5v5h-5z",
    fill: "#9c9b9a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m7 88c-2.005 0-3.452-1.919-2.901-3.846l2.901-10.154 2.901 10.154c.551 1.927-.896 3.846-2.901 3.846z",
    fill: "#f2ae40"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m69 72v-23h4v19z",
    fill: "#c9c7c6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m3 3h38v10h-38z",
    fill: "#c9c7c6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m17 3v18l5-5 5 5v-18z",
    fill: "#f2ae40"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9c9b9a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 45,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 45,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 45,
    r: 6
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 45,
    fill: "#c9c7c6",
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 45,
    fill: "#c9c7c6",
    r: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 45,
    fill: "#c9c7c6",
    r: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m3 46h3.08c.488 3.386 3.401 6 6.92 6 2.548 0 4.775-1.373 6-3.413 1.225 2.04 3.452 3.413 6 3.413 3.519 0 6.432-2.614 6.92-6h10.16c.488 3.386 3.401 6 6.92 6s6.432-2.614 6.92-6h6.08c.552 0 1-.447 1-1v-17c0-.176-.046-.349-.135-.501l-11-19c-.178-.309-.508-.499-.865-.499h-9v-5c0-.553-.448-1-1-1h-38c-.552 0-1 .447-1 1v31 11c0 .553.448 1 1 1zm10 4c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zm12 0c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zm24 0c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zm3.739-36 5.211 9h-9.95v-9zm-34.739-10h8v4c0 .553.448 1 1 1s1-.447 1-1v-4h12v5 2h-13c-.552 0-1 .447-1 1v6.586l-3.293-3.293c-.391-.391-1.023-.391-1.414 0l-3.293 3.293zm-14 0h12v7h-12zm0 9h12v8c0 .404.244.77.617.924.374.155.803.069 1.09-.217l4.293-4.293 4.293 4.293c.191.191.447.293.707.293.129 0 .259-.024.383-.076.373-.154.617-.52.617-.924v-8h12v20h-36zm0 22h37c.552 0 1-.447 1-1v-24h8.423l1.158 2h-4.581c-.552 0-1 .447-1 1v11c0 .553.448 1 1 1h12.108l1.892 3.269v15.731h-5.08c-.488-3.386-3.401-6-6.92-6s-6.432 2.614-6.92 6h-10.16c-.488-3.386-3.401-6-6.92-6-2.548 0-4.775 1.373-6 3.413-1.225-2.04-3.452-3.413-6-3.413-3.519 0-6.432 2.614-6.92 6h-2.08z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 30,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 30,
    r: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 30,
    r: 1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m88.661 20.207c1.432-1.282 2.339-3.139 2.339-5.207 0-3.859-3.14-7-7-7s-7 3.141-7 7c0 2.068.907 3.925 2.339 5.207-3.059.749-5.339 3.507-5.339 6.793v5c0 .553.448 1 1 1h18c.552 0 1-.447 1-1v-5c0-3.286-2.28-6.044-5.339-6.793zm-9.661-5.207c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5zm13 16h-16v-4c0-2.757 2.243-5 5-5h6c2.757 0 5 2.243 5 5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m25 42c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 4c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1-.449 1-1 1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m49 42c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 4c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1-.449 1-1 1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m13 42c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 4c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1-.449 1-1 1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m45 30h4c.552 0 1-.447 1-1s-.448-1-1-1h-4c-.552 0-1 .447-1 1s.448 1 1 1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m93 75h-17c-.552 0-1 .447-1 1v16h-33v-19.586l5-5v4.586c0 .404.244.77.617.924.374.156.803.069 1.09-.217l5.293-5.293v4.586c0 .404.244.77.617.924.374.156.804.069 1.09-.217l5.293-5.293v4.586c0 .404.244.77.617.924.373.156.803.069 1.09-.217l5.293-5.293v4.586c0 .404.244.77.617.924.374.156.803.069 1.09-.217l3.999-3.999.002-.002 1.292-1.292v4.586c0 .553.448 1 1 1s1-.447 1-1v-7c0-.404-.244-.77-.617-.924-.375-.156-.805-.069-1.09.217l-1.293 1.293v-16.586c0-.553-.448-1-1-1h-4c-.552 0-1 .447-1 1v15.586l-5 5v-4.586c0-.404-.244-.77-.617-.924-.375-.156-.804-.069-1.09.217l-5.293 5.293v-4.586c0-.404-.244-.77-.617-.924-.375-.156-.804-.069-1.09.217l-5.293 5.293v-4.586c0-.404-.244-.77-.617-.924-.375-.156-.804-.069-1.09.217l-7 7c-.187.187-.293.441-.293.707v20h-3v-5c0-.553-.448-1-1-1h-6c-.552 0-1 .447-1 1v5h-3v-23-9h14v7c0 .553.448 1 1 1s1-.447 1-1v-8c0-.553-.448-1-1-1h-16c-.552 0-1 .447-1 1v9h-10c-.552 0-1 .447-1 1v23h-5v-3.132c.872-.222 1.648-.725 2.207-1.466.766-1.016 1.005-2.299.655-3.521l-2.901-10.155c-.122-.43-.515-.726-.961-.726s-.839.296-.961.726l-2.901 10.154c-.35 1.223-.111 2.506.655 3.521.559.742 1.336 1.245 2.207 1.467v3.132h-3c-.552 0-1 .447-1 1s.448 1 1 1h90c.552 0 1-.447 1-1v-17c0-.553-.448-1-1-1zm-23-25h2v17.586l-2 2zm-64.61 36.197c-.385-.51-.504-1.154-.329-1.769l1.939-6.787 1.939 6.788c.175.614.056 1.259-.329 1.769-.769 1.019-2.451 1.019-3.22-.001zm18.61 5.803h-9v-22h9zm11 0h-4v-4h4zm51 0h-3v-3h3zm6 0h-4v-3h1c.552 0 1-.447 1-1s-.448-1-1-1h-9c-.552 0-1 .447-1 1s.448 1 1 1h1v3h-4v-15h15z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m46 77h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m51 77h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m56 77h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m61 77h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m66 77h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m71 77h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m46 81h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m51 81h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m56 81h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m61 81h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m66 81h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m71 81h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m46 85h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m51 85h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m56 85h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m31 63h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m36 63h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m31 67h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m36 67h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m31 71h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m18 74h3c.552 0 1-.447 1-1s-.448-1-1-1h-3c-.552 0-1 .447-1 1s.448 1 1 1z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m18 78h3c.552 0 1-.447 1-1s-.448-1-1-1h-3c-.552 0-1 .447-1 1s.448 1 1 1z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m18 82h3c.552 0 1-.447 1-1s-.448-1-1-1h-3c-.552 0-1 .447-1 1s.448 1 1 1z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m18 86h3c.552 0 1-.447 1-1s-.448-1-1-1h-3c-.552 0-1 .447-1 1s.448 1 1 1z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m18 90h3c.552 0 1-.447 1-1s-.448-1-1-1h-3c-.552 0-1 .447-1 1s.448 1 1 1z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m36 71h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m31 75h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m36 75h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m31 79h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m36 79h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m61 85h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m66 85h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m71 85h-1c-.552 0-1 .447-1 1s.448 1 1 1h1c.552 0 1-.447 1-1s-.448-1-1-1z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m80 81h9c.552 0 1-.447 1-1s-.448-1-1-1h-9c-.552 0-1 .447-1 1s.448 1 1 1z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m80 85h9c.552 0 1-.447 1-1s-.448-1-1-1h-9c-.552 0-1 .447-1 1s.448 1 1 1z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m17 63c-.552 0-1 .447-1 1v1c0 .553.448 1 1 1s1-.447 1-1v-1c0-.553-.448-1-1-1z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m18 59c0-.553-.448-1-1-1s-1 .447-1 1v1c0 .553.448 1 1 1s1-.447 1-1z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m18 54c0-.553-.448-1-1-1s-1 .447-1 1v1c0 .553.448 1 1 1s1-.447 1-1z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m74 14c.552 0 1-.447 1-1s-.448-1-1-1h-1c-.552 0-1 .447-1 1s.448 1 1 1z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m69 14c.552 0 1-.447 1-1s-.448-1-1-1h-1c-.552 0-1 .447-1 1s.448 1 1 1z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m64 14c.552 0 1-.447 1-1s-.448-1-1-1h-1c-.552 0-1 .447-1 1s.448 1 1 1z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m59 14c.552 0 1-.447 1-1s-.448-1-1-1h-1c-.552 0-1 .447-1 1s.448 1 1 1z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m84 72c0 .553.448 1 1 1s1-.447 1-1v-1c0-.553-.448-1-1-1s-1 .447-1 1z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m84 67c0 .553.448 1 1 1s1-.447 1-1v-1c0-.553-.448-1-1-1s-1 .447-1 1z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m84 62c0 .553.448 1 1 1s1-.447 1-1v-1c0-.553-.448-1-1-1s-1 .447-1 1z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m84 57c0 .553.448 1 1 1s1-.447 1-1v-1c0-.553-.448-1-1-1s-1 .447-1 1z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m84 52c0 .553.448 1 1 1s1-.447 1-1v-1c0-.553-.448-1-1-1s-1 .447-1 1z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m84 47c0 .553.448 1 1 1s1-.447 1-1v-1c0-.553-.448-1-1-1s-1 .447-1 1z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m84 42c0 .553.448 1 1 1s1-.447 1-1v-1c0-.553-.448-1-1-1s-1 .447-1 1z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m85 38c.552 0 1-.447 1-1v-1c0-.553-.448-1-1-1s-1 .447-1 1v1c0 .553.448 1 1 1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplier);
export default __webpack_public_path__ + "static/media/supplier.816aeccfb1e5c3965d112f7ae4ca41b0.svg";
export { ForwardRef as ReactComponent };